import { useCallback } from "react";

const ThumbnailStrip = ({
  images = [],
  currentIndex = 0,
  onSelect,
  darkMode,
}) => {
  const activeRef = useCallback(
    node => {
      if (node) {
        node.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
          inline: "nearest",
        });
      }
    },
    [currentIndex],
  );

  return (
    <div className="flex gap-2 overflow-x-auto py-2">
      {images.map((image, index) => (
        <button
          key={image?.archiveId ?? index}
          ref={index === currentIndex ? activeRef : undefined}
          onClick={() => onSelect(index)}
          className={`h-16 w-16 flex-shrink-0 overflow-hidden border-2 transition-colors ${
            index === currentIndex
              ? darkMode
                ? "border-white"
                : "border-black"
              : darkMode
                ? "border-gray-600 hover:border-gray-400"
                : "border-gray-200 hover:border-gray-400"
          }`}
        >
          <img
            src={image.imgT}
            alt={`Thumbnail ${index + 1}`}
            className="h-full w-full object-cover"
            onError={e => {
              e.target.style.visibility = "hidden";
            }}
          />
        </button>
      ))}
    </div>
  );
};

export default ThumbnailStrip;
